import { Loading, OmnijusCard, SelectObject } from "@omnijus/common";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Movimento } from "../../services/agendamento/models/movimento";
import { ProcessoService } from "../../services/processo/processo-service";
import { ReactComponent as DocumentIcon } from "../../assets/images/document-icon.svg";
import { BotaoDownloadDocumentosMovimento } from "../../shared/buttons/botao-download-documentos-movimento";

export const CardMovimentoGerador = ({
    idProcesso,
    idProcessoMovimento,
    handleDocumentoSelecionado,
}: {
    idProcesso: string;
    idProcessoMovimento?: string;
    handleDocumentoSelecionado: (documentoSelecionado: SelectObject | undefined) => void;
}) => {
    const [promise, setPromise] = useState<Promise<Movimento | undefined>>();

    useEffect(() => {
        if (idProcessoMovimento) {
            setPromise(ProcessoService.obterMovimento(idProcesso, idProcessoMovimento));
        } else {
            setPromise(Promise.resolve(undefined));
        }
    }, [idProcesso, idProcessoMovimento]);

    return (
        <Loading promise={promise}>
            {(movimentoGerador) => (
                <OmnijusCard
                    header={<h2>Movimento Gerador</h2>}
                    body={
                        <DataTable
                            pagination={false}
                            noDataComponent={<p>Não possui movimento vinculado</p>}
                            data={(movimentoGerador && ([{ ...movimentoGerador }] as Movimento[])) || []}
                            columns={[
                                {
                                    name: "Data",
                                    selector: (row) => row.data && new Date(row.data),
                                    format: (row) => row.data && format(new Date(row.data), "dd/MM/yyyy HH:mm"),
                                },
                                {
                                    name: "Fase",
                                    selector: (row) => row.fase,
                                    wrap: true,
                                },
                                {
                                    name: "Movimentação",
                                    selector: (row) => row.movimentacao,
                                    wrap: true,
                                },
                                {
                                    button: true,
                                    name: "Documento(s)",
                                    selector: (row) =>
                                        row.documentos?.length > 1 ? (
                                            <BotaoDownloadDocumentosMovimento
                                                idProcesso={idProcesso}
                                                idProcessoMovimento={row.idProcessoMovimento}
                                            />
                                        ) : row.documentos?.length === 1 ? (
                                            <DocumentIcon
                                                title={row.documentos[0].nome}
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                    handleDocumentoSelecionado({
                                                        label: `${row.documentos[0].tipo}: ${row.documentos[0].nome}`,
                                                        value: row.documentos[0].path,
                                                    });
                                                }}
                                            />
                                        ) : (
                                            "-"
                                        ),
                                    width: "7rem",
                                },
                            ]}
                        />
                    }
                />
            )}
        </Loading>
    );
};
